import { jsx as _jsx } from "react/jsx-runtime";
import { tailwindMerge } from "@air/tailwind-variants";
import { memo } from "react";
import { FileStatusIcon } from "./FileStatusIcon";
import { FileStatusPanelHeaderButtons } from "./FileStatusPanelHeaderButtons";
import { FileStatusPanelItem } from "./FileStatusPanelItem";
import { FileStatusSubtitle } from "./FileStatusSubtitle";
import { FileStatusTitle } from "./FileStatusTitle";
export const FileStatusPanelHeader = /*#__PURE__*/ memo((param)=>{
    let { isUploaderOpen, onToggle, status, title, subtitle, disableCancel, onCancel, onDismiss, onPause, onResume, className } = param;
    return /*#__PURE__*/ _jsx(FileStatusPanelItem, {
        className: tailwindMerge("px-4 py-3", isUploaderOpen ? "rounded-none" : "rounded", className),
        avatar: /*#__PURE__*/ _jsx(FileStatusIcon, {
            status: status
        }),
        title: /*#__PURE__*/ _jsx(FileStatusTitle, {
            "data-testid": "UPLOADER_TITLE",
            className: "font-semibold",
            children: title
        }),
        subtitle: /*#__PURE__*/ _jsx(FileStatusSubtitle, {
            className: "truncate",
            "data-testid": "UPLOADER_SUBTITLE",
            children: subtitle
        }),
        buttons: /*#__PURE__*/ _jsx(FileStatusPanelHeaderButtons, {
            status: status,
            onCancel: onCancel,
            onResume: onResume,
            disableCancel: disableCancel,
            onPause: onPause,
            isUploaderOpen: isUploaderOpen,
            onDismiss: onDismiss,
            onToggle: onToggle
        })
    });
});
FileStatusPanelHeader.displayName = "FileStatusPanelHeader";
